export const SET_BETS = 'SET_BETS';
export const SET_MULTI_BET_STAKE_POINTS = 'SET_MULTI_BET_STAKE_POINTS';
export const SET_ACCEPT_NEW_ODDS = 'SET_ACCEPT_NEW_ODDS';
export const TOGGLE_BETSLIP = 'TOGGLE_BETSLIP';
export const CLEAR_BETS = 'CLEAR_BETS';
export const FETCH_STAKE_LIMITS_SUCCESS = 'FETCH_STAKE_LIMITS_SUCCESS';
export const FETCH_STAKE_LIMITS_FAILED = 'FETCH_STAKE_LIMITS_FAILED';
export const SET_QB_ACTIVE = 'SET_QB_ACTIVE';
